import Vue from 'vue';
import VueRouter from 'vue-router';
import Resume from '@/pages/resume';

Vue.use(VueRouter);

export default new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'resume',
      component: Resume
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js